import React, { createContext, useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';

const DEFAULT_CONTAINER_ID = "co-portal-container";
const DEFAULT_ID = "co-portal";
const PortalContext = createContext(null);

const usePortal = () => {
  const portal = useContext(PortalContext);

  if (!portal) {
    throw new Error("You must use a PortalProvider to get a portal.");
  }

  return portal;
};

const Portal = ({
  children
}) => {
  const element = usePortal();
  return ReactDOM.createPortal(children, element);
};

const getPortalElement = (containerId, containerElement) => {
  const dataContainerId = `data-${containerId}`;
  let portal = containerElement.querySelector(`[${dataContainerId}]`);

  if (portal) {
    return portal;
  }

  portal = document.createElement("div");
  portal.setAttribute(dataContainerId, "true");
  portal.setAttribute("style", "position: fixed; top: 0; left: 0; width: 0; height: 0; z-index: 1400");
  containerElement.appendChild(portal);
  return portal;
};

const PortalProvider = ({
  children,
  containerId
}) => {
  const [portal, setPortal] = useState(null);
  useEffect(() => {
    const container = document.getElementById(containerId || DEFAULT_CONTAINER_ID);

    if (!container) {
      throw new Error(`There is no element with the "${containerId}" id.`);
    }

    const portal = getPortalElement(DEFAULT_ID, container);
    setPortal(portal);
    return () => {
      const portal = document.querySelector(`[data-${DEFAULT_ID}]`);

      if (portal) {
        portal.remove();
      }

      setPortal(null);
    };
  }, [containerId]);
  return React.createElement(PortalContext.Provider, {
    value: portal
  }, portal ? children : null, !containerId ? React.createElement("div", {
    id: DEFAULT_CONTAINER_ID
  }) : null);
};

export default PortalProvider;
export { Portal };
